import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import Page from 'modules/Page';
import { DETAILS_ROUTE_PATH as dashboardPath } from 'modules/project/ProjectAreaPage/constants';
import { i18n } from '@lingui/core';
import * as constants from './constants';

const BinderDeliveriesPage = lazyWithSuspense(() => import('./BinderDeliveriesPage'));

const page: Page = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  component: makePage(
    {
      WrappedPage: BinderDeliveriesPage,
      titleFn: () => i18n._(constants.TITLE),
      parentPathTemplate: dashboardPath,
      parentTitleFn: () => i18n._('Dashboard'),
    },
  ),
};

export default page;
